<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Prevención De Lavado de Activo
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="6" v-if="_.size(listGeneral.listaClientes) > 1">
                    <v-autocomplete label="Cliente *" color="textbox" v-model="objForm.objDatosGen.idCliente"
                        :items="listGeneral.listaClientes" :rules="requeridoRegla" outlined dense
                        @change="onListarCertificados" />
                </v-col>
                <v-col cols="12" sm="6" v-else>
                    <v-text-field label="Cliente *" color="textbox"
                        :value="_.get(listGeneral,['listaClientes','0','text'],null)" readonly outlined dense />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete label="N° Póliza-Certificado *" color="textbox" v-model="objForm.objDatosGen.id"
                        :items="listGeneral.listaCertificados" :rules="requeridoRegla" item-value="id"
                        item-text="certificado" @change="onListarDetalleCertificados" outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-text-field label="Seguro " color="textbox" v-model="objForm.objDatosGen.seguro" readonly outlined
                        dense />
                </v-col>
                <v-col>
                    <v-text-field label="Producto *" color="textbox" v-model="objForm.objDatosGen.producto" readonly
                        outlined dense />
                </v-col>
            </v-row>
            <v-row dense v-if="!print">
                <v-col cols="12" sm="12">
                    <StepperComponentVehiculo :objDatosGen="objForm.objDatosGen" :listaGeneral="listGeneral"
                        :parametro="parametro" />
                </v-col>
            </v-row>
            <v-row dense v-else>
                <v-col cols="12" sm="12">
                    <v-container fluid grid-list-md>
                        <v-row dense align="center" justify="center">
                            <v-col cols="12" sm="4" class="text-center">
                                <v-tooltip top color="primary" dar>
                                    <template v-slot:activator="{ on }">
                                        <!-- <v-btn color="primary" dark v-on="on" @click="loadFile"> -->
                                            <img :src="iconFile.base64" alt="File" v-on="on" @click="loadFile">
                                        <!-- </v-btn> -->
                                    </template>
                                    <span>Ver PDF</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row dense >
                            <v-col cols="12">
                                <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'PLAClienteView',
        components: {
            StepperComponentVehiculo: () => import('@/components/prevencionLavadoActivo/cliente/StepperComponentVehiculo.vue'),
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        data: () => ({
            print: false,
            listGeneral: {},
            parametro: {},
            objForm: {
                objDatosGen: {},
                idEstado: null
            },
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            },
            iconFile:{ base64: ''},
            next: false,
        }),
        created() {
            var error = 'E';

            axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/cargaGeneral`, {})
                .then((r) => {
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                        this.$set(this, 'listGeneral', r.data.data.listas);
                        this.$set(this, 'parametro', r.data.data.parametros);
                        this.$set(this.objForm.objDatosGen, 'idCliente', _.get(this.$root.obUsuario, 'idCliente',null));
                        this.$set(this.objForm, 'idEstado', this.parametro.idEstadoDefault);
                        this.onCargaGeneral();
                })
                .catch((e) => {
                    mensajesAlerta(e, error);
                });
        },
        watch:{
            print(val){
                this.iconFile.base64 = '';
                if(val){
                        axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': this.objForm.objDatosGen.path, 'mini' : true})
                             .then((r) => {
                                 if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                 if(_.size(_.get(r,['data','data'],[])) == 0) throw 'Error al leer el archivo PDF.';
                                    this.iconFile.base64 = JSON.parse(JSON.stringify(r.data.data));
                             })
                             .catch((e)=>{
                                mensajesAlerta(e,'E');
                             })
                }
            }
        },
        methods: {
            onCargaGeneral() {
                this.onListarClientes('L')
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                            this.onListarCertificados('L');
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            },
            onListarClientes(event) {
                if (!_.isUndefined(event)) {
                    var error = 'E';

                    var objeto = {
                        opcion: 'L',
                        idCliente: _.get(this.objForm.objDatosGen, 'idCliente', null)
                    };

                    return axios.post(`${BASE_URI}administrador/cliente/listar`, objeto)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                            if (_.size(this.listGeneral.listaClientes) == 0)
                                this.listGeneral.listaClientes = _.map(r.data.data, (o) => { o.text = o.cliente; o.value = o.idCliente; return o; });

                                this.$set(this.objForm, 'objDatosGen', r.data.data[0]);
                                this.print = false;

                            return r;
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                            return e;
                        });
                }
            },
            onListarCertificados(event) {
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    var objeto = {
                        opcion   : 'LISTAR_CER_PLA',
                        idCliente: _.get(this.objForm.objDatosGen, 'idCliente', null),
                        idTipoEstadoCertificadoProcesado: _.get(this.parametro, 'idTipoEstadoCertificadoProcesado',null)
                    };

                    return axios.post(`${BASE_URI}administrador/certificado/listar`, objeto)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }

                                this.listGeneral.listaCertificados = r.data.data;

                                var obj = _.find(this.listGeneral.listaClientes, (o) => { return parseInt(o.value) == parseInt(this.objForm.objDatosGen.idCliente) });
                                var m = _.merge({}, obj, r.data.data[0]);

                                this.$set(this.objForm, 'objDatosGen', m);
                                this.print = parseInt(_.get(this.objForm.objDatosGen,'idEstadoProcesado',0)) == parseInt(this.parametro.idEstadoDefault) ? true : false;
                                return r;
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                            return e;
                        });
                }
            },
            onListarDetalleCertificados(event) {
                if (!_.isUndefined(event)) {
                    var keysOmit = [
                                    'certificado', 'idCertificado', 'idPoliza', 'seguro', 'producto', 
                                    'idFormulario', 'idEstadoProcesado', 'path'
                                  ];

                    this.objForm.objDatosGen = _.omit(this.objForm.objDatosGen, keysOmit);

                    var certi = _.find(this.listGeneral.listaCertificados, (o) => { return parseInt(o.id) == parseInt(this.objForm.objDatosGen.id) });
                    this.objForm.objDatosGen = _.merge({}, this.objForm.objDatosGen, certi);

                    this.print = parseInt(_.get(this.objForm.objDatosGen,'idEstadoProcesado',0)) == parseInt(this.parametro.idEstadoDefault) ? true : false;
                }
            },
            loadFile(event){
                if(!_.isUndefined(event)){
                    var error = 'E';

                    axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': this.objForm.objDatosGen.path})
                         .then((r) => {
                             if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                             if(_.size(_.get(r,['data','data'],[])) == 0) { error= 'I'; throw 'Error al leer el archivo PDF.'; } 
                                 this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                 this.objPdf.titulo = 'Formulario de Prevención de Lavado de Activos';
                                 this.objPdf.mostrar = true;
                         })
                         .catch((e) => {
                             mensajesAlerta(e,error);
                         });
                }
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf: this.cerrarModalPdf
            }
        }
    }
</script>